import type { TranslationResources } from '../../types';

export const ru = {
  common: {
    labOpening: 'Открываем Mylo lab для вашего рабочего пространства…',
    labLaunchError:
      'Не удалось открыть Mylo lab. Проверьте соединение и повторите попытку. Если Lab недоступна в вашем регионе, обратитесь в поддержку.',
    labRetry: 'Повторить',

    brand: 'Мыло Студия',
    continue: 'Продолжить',
    cancel: 'Отмена',
    save: 'Сохранить изменения',
    reset: 'Сбросить демоданные',
    skip: 'Перейти к содержимому',
    search: 'Поиск',
    new: 'Новое',
    beta: 'Бета',
    open: 'Открыть',
    back: 'Назад',
    language: 'Язык',
    english: 'Английский',
    russian: 'Русский',
    chinese: 'Упрощённый китайский',
    credits: 'Мыло',
    sandbox: 'Песочница · международный регион',
    noResults: 'Здесь пока ничего нет',
    viewAll: 'Показать все',
    comingSoon: 'Скоро',
    errorStart: 'Не удалось запустить Мыло Студию',
    reload: 'Перезагрузить',
    switchToLightTheme: 'Переключиться на светлую тему',
    switchToDarkTheme: 'Переключиться на тёмную тему',
    download: 'Скачать',
    signOut: 'Выйти',
    enterStudio: 'Войти в Мыло Студию',
    demoHint: 'Пока вход через OAuth не настроен, используйте код из письма.',
    metricCreative: 'Креативные варианты',
    metricMarket: 'Рыночный контекст',
    metricAgent: 'Работа Агента',
    paidBeta: 'Платная бета-версия · рабочая среда',
    signIn: 'Войти',
    startCreating: 'Начать',
  },
  home: {
    skip: 'Перейти к содержимому',
    homeLabel: 'Главная страница Мыло Студии',
    sectionsLabel: 'Разделы главной страницы',
    galleryLabel: 'Примеры видео, созданных с помощью Мыло Агента',
    nav: ['Возможности', 'Примеры', 'Как работает', 'Модели'],
    actions: ['Открыть Агента', 'Создать видео', 'Смотреть примеры'],
    hero: {
      badge: 'ИИ-агент для создания видео',
      title: 'Превращай любые идеи в видео.',
      titleLines: ['Превращай', 'любые идеи', 'в видео.'],
      description:
        'Опиши идею по-русски и при желании добавь фото или видео. Мыло Агент поймёт задачу, подберёт подходящую модель и создаст готовое видео.',
      highlights: [
        'Говори по-русски',
        'Не нужно разбираться в промптах. Просто расскажи, что хочешь создать.',
        'Один Агент. Лучшие модели.',
        'Технологии меняются. Тебе не нужно за ними следить.',
      ],
      prompt: [
        'ПРОМПТ',
        'Создай футуристичный клип в неоновой стилистике.',
        'АГЕНТ ПОНЯЛ',
        'АГЕНТ СОЗДАЁТ',
        'ПРЕДПРОСМОТР',
        'ВИДЕО',
      ],
    },
    overview: [
      'Твоя ИИ-видеостудия',
      'Одна идея. Один Агент. Бесконечно много видео.',
      'Мем, эдит, история, клип, персонаж или целый новый мир — расскажи Мыло Агенту о своей идее. Он поможет превратить её в сценарий, сцены и готовое видео.',
    ],
    formats: ['Идея', 'Референс', 'Агент', 'Видео'],
    showcase: [
      'Что можно создать',
      'Листай. Смотри. Создавай своё.',
      'Из одной идеи можно создать десятки разных видео. Меняй стиль, персонажей и атмосферу — Агент поможет создать новую версию.',
      'Идея / Агент / Видео',
    ],
    materials: [
      'Как это работает',
      'Начни с чего угодно.',
      'Идея / Фото / Видео',
    ],
    pipeline: [
      ['Идея', 'текст + фото + видео'],
      ['Понимание', 'стиль + герой + сцены'],
      ['Агент', 'модель + генерация'],
      ['Видео', 'готовый результат'],
    ],
    submitItems: [
      'Опиши идею или загрузи фото, видео и референсы.',
      'Агент поймёт твою задумку: нужный стиль, героя, настроение и желаемый результат.',
      'Агент подберёт подходящую модель и подготовит всё к генерации.',
      'Просматривай результат, меняй детали и создавай новые версии.',
    ],
    context: [
      'По-русски. Без сложных промптов.',
      'Общайся с Агентом как с человеком.',
      'Не нужно учиться писать идеальные промпты. Опиши идею по-русски — Агент сам сформирует запрос для подходящей ИИ-модели.',
      'Видео на главной странице воспроизводятся без звука. Запусти Агента, чтобы создать свою версию.',
    ],
    groups: [
      ['Ты задаёшь', 'Идею', 'Фото или видео', 'Референсы', 'Настроение'],
      ['Агент создаёт', 'Сценарий', 'Сцены', 'Промпты', 'Готовые видео'],
    ],
    timeline: [
      'Новые модели. Больше возможностей.',
      'Один Агент — доступ к новым моделям в одном месте.',
      'Подключаем новые модели',
      'Агент сам определяет, какую модель использовать.',
      'А ты просто создаёшь.',
    ],
    footer: [
      'Твоя следующая идея',
      'А что ты создашь первым?',
      'Запусти Агента, опиши идею по-русски и посмотри, во что она превратится.',
    ],
    footerLegalNote: 'Правовая информация для региона RU.',
    legalNavLabel: 'Правовая информация',
    legalOffer: 'Условия использования',
    legalPrivacy: 'Политика конфиденциальности',
    legalPersonalDataConsent: 'Политика cookie',
    clips: [
      ['Неоновый клип', 'Клип'],
      ['Премиальный запуск', 'Стиль'],
      ['Гонка на пределе', 'Экшен'],
      ['История героя', 'История'],
      ['Эффектное появление', 'Персонаж'],
      ['Монтаж в такт музыке', 'Монтаж'],
      ['Ночной город', 'Атмосфера'],
      ['Красная нить', 'История'],
      ['Агент создаёт видео', 'Готовые видео'],
      ['Визуальный референс', 'Референс'],
      ['Движение без границ', 'Динамика'],
      ['Новый мир', 'Атмосфера'],
      ['Как создаётся видео', 'Процесс'],
    ],
    stories: [
      ['Неоновый клип', 'Идея превращается в футуристичный музыкальный клип.'],
      [
        'Премиальный запуск',
        'Референс задаёт свет, ритм и атмосферу премьеры.',
      ],
      [
        'Гонка на пределе',
        'Агент создаёт динамичную сцену, полную скорости и напряжения.',
      ],
      [
        'История героя',
        'Из персонажа и идеи складывается короткая визуальная история.',
      ],
      [
        'Эффектное появление',
        'Даже один момент может стать запоминающейся сценой.',
      ],
      [
        'Монтаж в такт музыке',
        'Движение, музыка и переходы складываются в динамичный ролик.',
      ],
      ['Ночной город', 'Огни ночного города задают атмосферу новой версии.'],
      ['Красная нить', 'Один визуальный мотив связывает всю историю.'],
    ],
  },
  auth: {
    eyebrow: 'ИИ-платформа для создания видео',
    title: 'Создавайте рекламные материалы для русскоязычного рынка.',
    subtitle:
      'Создавайте и тестируйте разные видеоконцепции на основе данных о продукте, референсов и собственных идей.',
    google: 'Продолжить через Google',
    vk: 'Продолжить через VK',
    emailAddress: 'Email',
    verificationCode: 'Код подтверждения',
    sendCode: 'Отправить код',
    loginWithEmail: 'Войти по email',
    emailWorking: 'Проверяем…',
    codePrinted: 'Код подтверждения выведен в консоль сервера.',
    emailFailed:
      'Не удалось войти. Проверьте код из письма и повторите попытку.',
    terms:
      'Продолжая, вы принимаете <termsLink>Условия использования</termsLink> и <privacyLink>Политику конфиденциальности</privacyLink>.',
    working: 'Входим через {{provider}}…',
    success: 'Вход выполнен.',
    cancelled: 'Вход отменён. Выберите другой способ входа.',
    failed: 'Не удалось выполнить вход. Попробуйте ещё раз.',
    email: 'Электронная почта',
    password: 'Пароль',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    displayName: 'Отображаемое имя',
    register: 'Создать аккаунт',
    login: 'Войти',
    registerTitle: 'Создайте аккаунт',
    registerSubtitle: 'Введите данные для начала работы.',
    loginTitle: 'Добро пожаловать',
    loginSubtitle: 'Войдите в аккаунт.',
    orContinueWith: 'Или продолжить через',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    dontHaveAccount: 'Нет аккаунта?',
    passwordMinLength:
      'Не менее 10 символов и уровень «Надёжный». Длинные фразы надёжнее.',
    confirmPassword: 'Подтвердите пароль',
    passwordsDoNotMatch: 'Пароли не совпадают',
    passwordTooShort: 'Пароль должен содержать не менее 10 символов.',
    passwordTooWeak:
      'Пароль должен быть на уровне «Надёжный». Используйте более длинную и менее предсказуемую фразу.',
    passwordValidationUnavailable:
      'Проверка пароля временно недоступна. Повторите попытку.',
    retry: 'Повторить',
    passwordStrength: {
      score0: 'Очень слабый',
      score1: 'Слабый',
      score2: 'Средний',
      score3: 'Хороший',
      score4: 'Надёжный',
    },
    emailRequired: 'Введите электронную почту',
    passwordRequired: 'Введите пароль',
    invalidEmail: 'Введите корректный адрес электронной почты',
    emailAlreadyExists: 'Аккаунт с этой почтой уже существует',
    invalidCredentials: 'Неверная почта или пароль',
    region: {
      boundary: 'Хранение данных',
      title: 'Выберите регион хранения данных',
      description:
        'Перед входом выберите регион. Аккаунты и рабочие пространства в разных регионах хранятся отдельно. Перенос данных между регионами недоступен.',
      russia: 'Россия',
      russiaDetail:
        'Данные аккаунта и рабочего пространства хранятся в России.',
      global: 'Международный',
      globalDetail:
        'Данные аккаунта и рабочего пространства хранятся в международном регионе.',
      continue: 'Продолжить в {{region}} →',
      connecting: 'Подключаемся к региону «{{region}}»…',
      unavailable: 'Регион «{{region}}» недоступен',
      blocked: 'Подключение к региону заблокировано',
      verifyFailed: 'Не удалось проверить подключение к выбранному региону.',
      noLogin: 'Не удалось отправить запрос на вход.',
      retry: 'Повторить',
      choose: 'Выбрать регион',
    },
  },
  navigation: {
    account: 'Аккаунт',
    menu: 'Открыть навигацию',
    collapseSidebar: 'Свернуть боковую панель',
    expandSidebar: 'Развернуть боковую панель',
  },
  onboarding: {
    step: 'Настройка компании',
    title: 'Создайте первое рабочее пространство',
    subtitle:
      'Укажите данные о компании, основном рынке и регионе хранения данных, чтобы настроить рабочее пространство.',
    name: 'Название компании',
    website: 'Сайт',
    industry: 'Отрасль',
    size: 'Размер компании',
    jobTitle: 'Ваша должность',
    market: 'Основной рынок',
    region: 'Регион хранения данных',
    regionHint:
      'Регион хранения данных нельзя изменить после создания рабочего пространства. Чтобы выбрать другой регион, создайте новую компанию.',
    logo: 'Логотип компании',
    chooseLogo: 'Выбрать файл',
    noLogoSelected: 'Файл не выбран',
    create: 'Создать рабочее пространство',
    industries: {
      ecommerce: 'Электронная коммерция',
      agency: 'Маркетинговое агентство',
      gaming: 'Игры и приложения',
      brand: 'Бренд потребительских товаров',
      other: 'Другое',
    },
    sizes: {
      small: '1–10',
      medium: '11–50',
      large: '51–250',
      enterprise: '250+',
    },
    markets: { ru: 'Россия', cis: 'СНГ', global: 'Международный' },
  },
  billing: {
    title: 'Тарифы и оплата',
    sharedBy: 'Мыло доступно всем участникам {{workspace}}.',
    sharedBalance: 'Общий баланс мыла',
    credits: 'мыла',
    choosePlan: 'Выберите тариф',
    displayOnly: 'Цены указаны для справки. Оплата пока недоступна.',
    secureCheckout: 'Оплата безопасно проходит через ЮKassa.',
    continueToPayment: 'Перейти к оплате',
    pendingPlanPayment:
      'У вас есть незавершенный заказ {{plan}}, {{cadence}} ({{amount}})',
    annualCadence: 'за год',
    monthlyCadence: 'за месяц',
    continuePendingPayment: 'Продолжить оплату',
    abandonPendingPayment: 'Отменить и выбрать заново',
    abandoningPendingPayment: 'Отменяем платеж…',
    abandonPendingPaymentError:
      'Платеж пока нельзя отменить. Продолжите оплату или повторите попытку позже.',
    openingCheckout: 'Открываем безопасную оплату…',
    annualUnavailable: 'Годовая оплата скоро',
    annualAfterCurrentTerm:
      'Годовой тариф можно купить после окончания текущего оплаченного периода.',
    annualTermLocked:
      'Изменить или купить тариф снова можно после окончания текущего годового периода.',
    checkoutError: 'Не удалось начать оплату. Попробуйте ещё раз.',
    insufficientCreditsTitle: 'Недостаточно мыла для генерации',
    insufficientCreditsNeed: 'Для генерации нужно',
    insufficientCreditsHave: '. Доступно',
    insufficientCreditsNeedMore: ', не хватает',
    insufficientCreditsMoreSuffix: '.',
    requiredCreditsOnlyPrefix: 'Для генерации нужно',
    requiredCreditsOnlySuffix: '.',
    insufficientCreditsSummary:
      'Для генерации нужно {{required}} кредитов. Доступно {{available}}, не хватает {{shortage}}.',
    requiredCreditsOnly: 'Для генерации нужно {{required}} кредитов.',
    loadingPlans: 'Загрузка тарифов…',
    plansLoadError: '{{message}} Закройте окно и попробуйте ещё раз.',
    buyCredits: 'Купить мыло',
    getCredits: 'Получить мыло',
    workspaceCredits: 'Мыло рабочего пространства',
    renewsOn: 'Следующее начисление мыла — {{date}}',
    creditRefreshOn: 'Следующее начисление мыла — {{date}}',
    planEndsOn: 'Тариф действует до {{date}}',
    noAutomaticRenewal: 'Без автоматического продления',
    noScheduledRefresh: 'Следующее начисление мыла не запланировано',
    renewYourPlan: 'Продлить тариф',
    planExpiredTitle: 'Срок действия тарифа истёк',
    planExpiredDescription:
      'Продлите подписку, чтобы продолжить генерацию. Купленное мыло остаётся в вашем рабочем пространстве; пополнение мыла не продлевает тариф.',
    watermarkUpgradeDescription:
      'Перейдите на Pro, чтобы скачивать оригиналы изображений и видео без водяных знаков.',
    upgradeToPro: 'Перейти на Pro',
    upgradeYourPlan: 'Повысить тариф',
    comingSoon: 'Скоро',
    creditsComingSoon:
      'Скоро мыло можно будет покупать самостоятельно. Пока зачислить его на баланс рабочего пространства может оператор.',
    creditPackDescription: 'Добавьте мыло, не меняя текущий тариф.',
    creditPackRequiresPlan: 'Пакеты мыла доступны на активном платном тарифе.',
    oneTimeCreditPack: 'Разовый пакет мыла',
    creditPackNoRenewal: 'Разовая оплата без автоматического продления.',
    creditPackPaidPlanOnly: 'Доступен, пока действует платный тариф.',
    buyCreditPack: 'Купить 1 000 мыла',
    current: 'Текущий',
    currentPlan: 'Текущий тариф',
    perMonth: 'в месяц',
    once: 'один раз',
    monthly: 'Ежемесячно',
    yearlyDiscount: 'Ежегодно · скидка {{discount}}%',
    billingCadence: 'Период оплаты',
    billedAnnually: 'Оплата раз в год',
    annualTotal: 'За год — {{price}}',
    customPricing: 'Индивидуальная цена',
    customCredits: 'Индивидуальное мыло',
    planNames: {
      FREE: 'Бесплатный',
      STANDARD: 'Стандартный',
      PRO: 'Профессиональный',
      MAX: 'Максимальный',
      ENTERPRISE: 'Корпоративный',
    },
    badges: { POPULAR: 'Популярный', BEST_VALUE: 'Выгодный выбор' },
    entitlements: {
      CORE_AGENT: 'Творческий ИИ-агент',
      IMAGE_AND_VIDEO_TOOLS: 'Инструменты генерации изображений и видео',
      PRIVATE_ASSET_LIBRARY: 'Закрытая библиотека рабочего пространства',
      ECONOMY_VIDEO_MODEL: 'Экономичная модель Мыло Видео 2.0 Mini, до 720p',
      INCLUDES_FREE: 'Все возможности бесплатного тарифа',
      ALL_PRODUCTION_MODELS: 'Все доступные модели.',
      MONTHLY_CREDIT_REFRESH: 'Ежемесячное начисление мыла',
      CREDIT_PACK_PURCHASES: 'Можно докупать пакеты мыла',
      VIDEO_UP_TO_1080P: 'Все модели Мыло Видео, до 1080p',
      INCLUDES_STANDARD: 'Все возможности стандартного тарифа',
      HIGHER_MONTHLY_GENERATION_ALLOWANCE: 'Больше генераций каждый месяц',
      API_ACCESS: 'Доступ к API для разработчиков',
      WATERMARK_FREE_VIDEOS: 'Скачивание видео без водяного знака',
      WATERMARK_FREE_IMAGES: 'Скачивание изображений без водяного знака',
      WATERMARK_FREE_VIDEO_EDITOR_EXPORTS:
        'Экспорт из видеоредактора без водяного знака',
      VIDEO_UP_TO_4K: 'Генерация видео в 4K',
      INCLUDES_PRO: 'Все возможности профессионального тарифа',
      HIGHEST_MONTHLY_GENERATION_ALLOWANCE:
        'Максимальное количество генераций в месяц',
      ONE_MONTH_CREDIT_ROLLOVER:
        'Неиспользованное мыло переносится на один месяц',
      INCLUDES_MAX: 'Все возможности максимального тарифа',
      CUSTOM_CREDITS: 'Настраиваемое количество мыла',
      CUSTOM_TEAM_SIZE: 'Настраиваемое количество участников',
      ENTERPRISE_SUPPORT: 'Настройка и поддержка для корпоративных клиентов',
    },
    includedCreditsLabel: 'Включено',
    includedCredits: 'Включено кредитов: {{count}}',
    upgradePlan: 'Изменить тариф',
    creditTimeline: 'Срок действия кредитов',
    timelineHint: 'Сначала показаны кредиты, которые истекают раньше.',
    noGrants: 'Начислений пока нет.',
    expires: 'Истекают {{date}}',
    neverExpires: 'Без срока действия',
    planCredits: 'Мыло тарифа',
    carriedCredits: 'Перенесённое мыло',
    purchasedCredits: 'Купленное мыло',
    promotionalCredits: 'Промо-мыло',
    existingCredits: 'Ранее начисленное мыло',
    checkoutSoon:
      'Оплата скоро станет доступна. Пока изменить тариф или баланс мыла рабочего пространства может только оператор.',
    chooseWorkspace:
      'Выберите рабочее пространство, чтобы посмотреть тариф и данные об оплате.',
    loading: 'Загружаем данные об оплате…',
    loadError: 'Не удалось загрузить данные об оплате',
    loadErrorHint: 'Обновите страницу и попробуйте снова.',
    creditUsage: 'Использование мыла',
    creditUsageHint:
      'История всех изменений баланса мыла в этом рабочем пространстве.',
    activityTypeFilter: 'Тип операции',
    allActivityTypes: 'Все операции',
    activityLoading: 'Загрузка операций…',
    activityLoadError: 'Не удалось загрузить операции. Попробуйте снова.',
    noActivity: 'Операций с кредитами пока нет.',
    previous: 'Назад',
    next: 'Далее',
    activityColumns: {
      date: 'Дата',
      event: 'Событие',
      type: 'Тип',
      change: 'Изменение',
      status: 'Статус',
    },
    activityTypes: {
      GENERATION: 'Генерация',
      TOP_UP: 'Пополнение',
      PLAN_GRANT: 'Кредиты тарифа',
      CARRYOVER: 'Перенос',
      PROMOTION: 'Бонус',
      REFUND: 'Возврат',
      ADMIN_ADJUSTMENT: 'Корректировка',
      EXPIRY: 'Истечение срока действия',
      OTHER: 'Другое',
    },
    activityStatuses: {
      COMPLETED: 'Завершено',
      HELD: 'В резерве',
      RELEASED: 'Резерв снят',
    },
    credit: {
      topUp: 'Кредиты добавлены',
      generationHeld: 'Кредиты зарезервированы на время генерации',
      labUsed: 'Мыло списано за Mylo lab',
      generationUsed: 'Кредиты списаны за генерацию',
      generationReleased: 'Зарезервированные кредиты возвращены',
      refund: 'Кредиты возвращены',
      adminAdjustment: 'Корректировка кредитов',
      planGrant: 'Кредиты тарифа начислены',
      carryover: 'Кредиты перенесены',
      promotion: 'Бонусные кредиты начислены',
      existingBalance: 'Начальный баланс перенесён',
      expired: 'Срок действия кредитов истёк',
      merchantAdjustment: 'Корректировка баланса оператором',
      other: 'Операция с кредитами',
    },
  },
  developerApi: {
    eyebrow: 'Доступ разработчиков рабочего пространства',
    title: 'MyloStudio API',
    description:
      'Создавайте серверные ключи для {{workspace}} и оплачивайте генерацию изображений и видео кредитами рабочего пространства.',
    activeKeys: 'Активных ключей: {{count}}',
    proBenefit: 'Преимущество Pro',
    lockedTitle: 'Создавайте приложения с MyloStudio API',
    lockedDescription:
      'Перейдите на тариф Pro или выше, чтобы создавать API-ключи и использовать кредиты рабочего пространства через API для разработчиков.',
    upgradeToPro: 'Перейти на Pro',
    keyName: 'Название ключа',
    keyNamePlaceholder: 'Продакшен-сервер…',
    expiresAt: 'Срок действия (необязательно)',
    permissions: 'Разрешения',
    createKey: 'Создать API-ключ',
    creating: 'Создание…',
    keysTitle: 'API-ключи',
    maxKeys: 'До 5 активных ключей',
    loading: 'Загрузка API-ключей…',
    emptyTitle: 'API-ключей пока нет',
    emptyDescription:
      'Укажите систему, которая будет использовать ключ, и создайте его выше.',
    active: 'Активен',
    expired: 'Истёк',
    revoked: 'Отозван',
    keyMeta:
      'Создал {{creator}}, {{date}} · Последнее использование: {{lastUsed}}',
    never: 'никогда',
    revoke: 'Отозвать',
    revokeConfirm:
      'Отозвать «{{name}}»? Использующие его приложения сразу перестанут работать.',
    quickStart: 'Быстрый старт',
    quickStartDescription:
      'Храните ключи на сервере. Не добавляйте их в код браузера или URL.',
    viewApiDocs: 'Открыть документацию API',
    imageExample: 'Генерация изображений',
    videoExample: 'Генерация видео',
    createdTitle: 'Скопируйте API-ключ',
    createdDescription:
      'Секрет показывается один раз. Сохраните его в менеджере секретов перед закрытием.',
    copyKey: 'Скопировать ключ',
    copied: 'Скопировано',
    done: 'Готово',
    chooseWorkspace:
      'Выберите рабочее пространство для управления API-ключами.',
    loadError: 'Не удалось загрузить API-ключи.',
    createError: 'Не удалось создать API-ключ.',
    revokeError: 'Не удалось отозвать API-ключ.',
  },
  account: {
    title: 'Настройки аккаунта',
    workspaceSettings: 'Настройки рабочего пространства',
    workspaceSettingsTab: 'Настройки',
    workspaceMembersTab: 'Участники',
    workspaceBillingTab: 'Тарифы и оплата',
    workspaceEyebrow: 'Управление рабочим пространством',
    workspaceSettingsDescription:
      'Просматривайте рабочие пространства и изменяйте их основные настройки.',
    workspaceDetails: 'Данные рабочего пространства',
    workspaceDetailsHint:
      'Изменять данные рабочего пространства могут только владельцы и администраторы.',
    workspaceName: 'Название рабочего пространства',
    workspaceNameRequired: 'Введите название рабочего пространства.',
    workspaceUpdated: 'Рабочее пространство обновлено',
    workspaceUpdateFailed:
      'Не удалось обновить рабочее пространство. Повторите попытку.',
    workspaceReadOnly:
      'У вас нет прав на изменение настроек этого рабочего пространства.',
    currentWorkspace: 'Текущее рабочее пространство',
    noWorkspaces: 'Нет доступных рабочих пространств.',
    createNewWorkspace: 'Создать рабочее пространство',
    createWorkspace: 'Создать рабочее пространство',
    manageWorkspaces: 'Управление рабочими пространствами',
    regionLabel: 'Регион: {{region}}',
    activeRegionName: 'Альфа-версия',
    close: 'Закрыть',
    createWorkspaceFailed:
      'Не удалось создать рабочее пространство. Повторите попытку.',
    switchWorkspaceFailed:
      'Не удалось сменить рабочее пространство. Повторите попытку.',
    plansAndBilling: 'Тарифы и оплата',
    accountProfile: 'Профиль аккаунта',
    profileDescription: 'Изменяйте имя, аватар и данные для входа.',
    changeAvatar: 'Изменить аватар',
    avatarHint: 'JPG, PNG или WebP. Не более 5 МБ.',
    uploadingAvatar: 'Загрузка {{progress}}%',
    avatarTypeError: 'Выберите изображение JPG, PNG или WebP.',
    avatarSizeError: 'Выберите изображение размером не более 5 МБ.',
    avatarUploadFailed: 'Не удалось загрузить аватар. Повторите попытку.',
    avatarUpdated: 'Аватар обновлён',
    userId: 'ID пользователя',
    copyUserId: 'Скопировать ID пользователя',
    copied: 'Скопировано',
    signInMethods: 'Способы входа',
    signInMethodsHint: 'Способы входа, привязанные к вашему аккаунту Мыло.',
    connected: 'Подключено',
    notConnected: 'Не подключено',
    saveChanges: 'Сохранить изменения',
    saving: 'Сохранение…',
    changesSaved: 'Изменения сохранены',
    saveFailed: 'Не удалось сохранить изменения. Повторите попытку.',
    displayNameRequired: 'Введите отображаемое имя.',
    upgradePlan: 'Повысить тариф',
    developerApi: 'API для разработчиков',
    inviteMembers: 'Пригласить участников',
    referFriend: 'Пригласить друга',
    workspace: 'Рабочее пространство',
    theme: 'Тема',
    themeOptions: 'Варианты темы',
    languageOptions: 'Варианты языка',
    system: 'Системная',
    light: 'Светлая',
    dark: 'Тёмная',
    switchWorkspace: 'Сменить рабочее пространство',
    logOut: 'Выйти',
    profile: 'Профиль',
    security: 'Безопасность',
    companies: 'Компании',
    members: 'Участники',
    language: 'Язык',
    preferences: 'Предпочтения',
    wallet: 'Кошелёк',
    displayName: 'Отображаемое имя',
    email: 'Электронная почта',
    provider: 'Способ входа',
    providers: 'Способы входа',
    current: 'Текущая',
    switchCompany: 'Сменить компанию',
    addCompany: 'Добавить компанию',
    dataRegion: 'Регион данных',
    appearance: 'Оформление',
    notifications: 'Уведомления о генерации',
    resetHint:
      'Удалить локальные данные демосессии, компаний, проектов и материалов.',
    confirmReset:
      'Удалить локальные данные демосессии, включая компании, проекты и материалы?',
    balance: 'Баланс',
    credits: 'Кредиты',
    currency: 'Валюта',
    creditRecords: 'История операций с кредитами',
    noCreditRecords: 'Операций с кредитами пока нет.',
    filterType: 'Тип',
    filterDateFrom: 'С',
    filterDateTo: 'По',
    allTypes: 'Все типы',
    resetFilter: 'Сбросить',
    applyFilter: 'Применить',
    ledgerType: {
      TOP_UP: 'Пополнение',
      HOLD: 'Резервирование',
      CAPTURE: 'Списание',
      RELEASE: 'Снятие резерва',
      REFUND: 'Возврат',
      ADMIN_ADJUSTMENT: 'Корректировка администратора',
      SUBSCRIPTION_CHARGE: 'Оплата подписки',
      PROMOTIONAL_CREDIT: 'Начисление бонусных кредитов',
      EXPIRED_CREDIT: 'Истёкший кредит',
      MERCHANT_CREDIT_ADJUSTMENT: 'Корректировка баланса оператором',
    },
    topUp: 'Пополнить',
    transactionType: 'Тип',
    transactionAmount: 'Сумма',
    transactionDate: 'Дата',
    linkedAccounts: 'Привязанные аккаунты',
    unlink: 'Отвязать',
    link: 'Привязать',
    activeDevices: 'Активные устройства',
    thisDevice: 'Это устройство',
    unknownDevice: 'Неизвестное устройство',
    expires: 'Истекает',
    revoke: 'Завершить сеанс',
    dangerZone: 'Опасная зона',
    deleteWorkspace: 'Удалить рабочее пространство',
    deleteWorkspaceHint:
      'Рабочее пространство можно восстановить в течение 30 дней.',
    role: 'Роль',
    owner: 'Владелец',
    admin: 'Администратор',
    member: 'Участник',
    personalInfo: 'Личные данные',
    connectedAccounts: 'Подключённые аккаунты',
    workspaceList: 'Список рабочих пространств',
    selectWorkspace: 'Выберите рабочее пространство.',
    yourRole: 'Ваша роль: {{role}}.',
    regionLocked: 'Регион хранения данных: {{region}}. Изменить его нельзя.',
    you: 'вы',
    vkIdentity: 'Учётная запись VK',
    transferOwnership: 'Передать владение',
    remove: 'Удалить',
    invitePeople: 'Пригласить участников',
    inviteExpiryHint:
      'Ссылка действует семь дней и может быть использована один раз.',
    invitationRole: 'Роль нового участника',
    createSecureLink: 'Создать защищённую ссылку',
    invitationLink: 'Ссылка-приглашение',
    copy: 'Копировать',
    pending: 'Ожидает',
    accepted: 'Принято',
    revoked: 'Отозвано',
    expired: 'Истекло',
    transferOwnershipTitle: 'Передать владение?',
    removeMemberTitle: 'Удалить участника?',
    revokeInvitationTitle: 'Отозвать приглашение?',
    transferOwnershipDescription:
      'Передать это рабочее пространство пользователю {{name}}?',
    removeMemberDescription:
      'Удалить пользователя {{name}} из рабочего пространства?',
    revokeInvitationDescription:
      'Эта ссылка-приглашение сразу перестанет работать.',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    membersLoadError: 'Не удалось загрузить участников рабочего пространства.',
    deviceExpires: 'Сеанс завершится {{date}}',
    deletedWorkspaces: 'Удалённые рабочие пространства',
    deletedWorkspacesHint:
      'Владелец может восстановить рабочее пространство в течение 30 дней.',
    purgeDate: 'Окончательное удаление — {{date}}',
    purgePending: 'Ожидает удаления',
    restore: 'Восстановить',
    noDeletedWorkspaces: 'Удалённых рабочих пространств нет.',
    joiningWorkspace: 'Присоединяемся к рабочему пространству…',
    inviteAcceptError: 'Не удалось принять приглашение.',
  },
  validation: {
    required: 'Заполните это поле.',
    website: 'Введите корректный адрес сайта.',
    logoSize: 'Выберите изображение размером до 5 МБ.',
  },
  studio: {
    campaignBriefForm: {
      targetAudience: 'Целевая аудитория',
      platforms: 'Платформы',
      campaignGoal: 'Цель кампании',
      keyMessage: 'Ключевое сообщение',
      tone: 'Тон',
      cta: 'Призыв к действию',
      constraints: 'Ограничения',
      targetAudiencePlaceholder: 'Например: городские специалисты 25–34 лет',
      platformsPlaceholder: 'Например: Instagram Reels и TikTok',
      campaignGoalPlaceholder:
        'Например: повысить узнаваемость нового продукта',
      keyMessagePlaceholder:
        'Например: заметно более сияющая кожа уже через 7 дней',
      tonePlaceholder: 'Например: лаконичный, премиальный, уверенный',
      ctaPlaceholder: 'Например: «Купить набор»',
      constraintsPlaceholder:
        'Например: не использовать медицинские обещания, сохранить белый цвет упаковки',
      custom: 'Свой вариант',
      customLabel: 'Свой вариант: {{field}}',
      targetAudienceQuestion:
        'На какую аудиторию рассчитаны изображения для этой кампании?',
      platformsQuestion:
        'На каких платформах будут размещаться эти изображения?',
      campaignGoalQuestion: 'Какого результата должна достичь эта кампания?',
      closeTool: 'Закрыть форму',
      previousQuestion: 'Предыдущий вопрос',
      nextQuestion: 'Следующий вопрос',
      required: 'обязательно',
      requiredHint: 'Ответьте на обязательные вопросы, чтобы продолжить.',
      skip: 'Пропустить',
      stepOf: 'из',
      typeOwnAnswer: 'Введите свой ответ',
      targetAudienceOptionGenZ: 'Поколение Z и тренды',
      targetAudienceOptionGenZHint:
        'Пользователи соцсетей, которые следят за визуальными трендами',
      targetAudienceOptionProfessionals: 'Городские профессионалы',
      targetAudienceOptionProfessionalsHint:
        'Премиальная повседневная подача для занятых людей',
      targetAudienceOptionParents: 'Молодые родители',
      targetAudienceOptionParentsHint:
        'Понятная демонстрация продукта и его преимуществ',
      targetAudienceOptionFitness: 'Любители фитнеса',
      targetAudienceOptionFitnessHint:
        'Наглядное сравнение эффективности с премиальной подачей',
      platformsOptionInstagram: 'Лента и истории Instagram',
      platformsOptionInstagramHint:
        'Материалы, адаптированные для ленты и историй Instagram',
      platformsOptionTikTok: 'Изображения для TikTok',
      platformsOptionTikTokHint:
        'Изображения продукта, понятные с первого взгляда',
      platformsOptionXhs: 'Публикации в Xiaohongshu',
      platformsOptionXhsHint:
        'Материалы для знакомства с продуктом и наглядной демонстрации его преимуществ и деталей',
      platformsOptionMultiStatic: 'Статика для разных платформ',
      platformsOptionMultiStaticHint:
        'Универсальные материалы для обычных и рекламных публикаций',
      campaignGoalOptionLaunch: 'Запуск продукта',
      campaignGoalOptionLaunchHint:
        'Представить новый продукт и вызвать к нему интерес',
      campaignGoalOptionConversions: 'Повысить конверсию',
      campaignGoalOptionConversionsHint:
        'Подвести зрителя к покупке или заявке',
      campaignGoalOptionBenefits: 'Объяснить выгоды',
      campaignGoalOptionBenefitsHint:
        'Сделать ключевую ценность очевидной и запоминающейся',
      campaignGoalOptionRetarget: 'Ретаргетинг',
      campaignGoalOptionRetargetHint:
        'Вернуть заинтересованную аудиторию и подтолкнуть её к действию',
      submit: 'Создать визуальные концепции',
    },
    videoBriefForm: {
      targetAudience: 'Целевая аудитория',
      platforms: 'Платформы',
      campaignGoal: 'Цель кампании',
      hook: 'Яркое начало (первые 3 секунды)',
      keyMessage: 'Ключевое сообщение',
      tone: 'Тон',
      cta: 'Призыв к действию',
      constraints: 'Ограничения',
      targetAudiencePlaceholder: 'Например: городские специалисты 25–34 лет',
      platformsPlaceholder: 'Например: TikTok и Instagram Reels',
      campaignGoalPlaceholder:
        'Например: повысить узнаваемость нового продукта',
      hookPlaceholder: 'напр. резкий монтаж продукта с ярким тезисом',
      keyMessagePlaceholder:
        'Например: легче носить, дольше работает и выглядит аккуратнее',
      tonePlaceholder: 'Например: динамичный, премиальный, живой',
      ctaPlaceholder: 'Например: «Попробовать сегодня»',
      constraintsPlaceholder:
        'Например: логотип должен оставаться в кадре, не указывать цену',
      custom: 'Свой вариант',
      customLabel: 'Свой вариант: {{field}}',
      targetAudienceQuestion: 'На какую аудиторию рассчитана эта реклама?',
      platformsQuestion: 'На каких платформах будет опубликован этот ролик?',
      campaignGoalQuestion: 'Какого результата должен достичь этот ролик?',
      closeTool: 'Закрыть форму',
      previousQuestion: 'Предыдущий вопрос',
      nextQuestion: 'Следующий вопрос',
      required: 'обязательно',
      requiredHint: 'Ответьте на обязательные вопросы, чтобы продолжить.',
      skip: 'Пропустить',
      stepOf: 'из',
      typeOwnAnswer: 'Введите свой ответ',
      targetAudienceOptionGenZ: 'Поколение Z и тренды',
      targetAudienceOptionGenZHint:
        'Пользователи платформ коротких видео, которые следят за трендами и блогерами',
      targetAudienceOptionProfessionals: 'Городские профессионалы',
      targetAudienceOptionProfessionalsHint:
        'Премиальные сценарии повседневного использования',
      targetAudienceOptionParents: 'Молодые родители',
      targetAudienceOptionParentsHint: 'Практичные выгоды и экономия времени',
      targetAudienceOptionFitness: 'Любители фитнеса',
      targetAudienceOptionFitnessHint:
        'Наглядное сравнение эффективности с премиальной подачей',
      platformsOptionTikTok: 'TikTok',
      platformsOptionTikTokHint:
        'Яркое начало и естественная для TikTok динамика',
      platformsOptionReels: 'Instagram Reels',
      platformsOptionReelsHint:
        'Наглядная демонстрация продукта в повседневных ситуациях',
      platformsOptionShorts: 'YouTube Shorts',
      platformsOptionShortsHint:
        'Понятная демонстрация продукта с учётом поисковых запросов',
      platformsOptionAllShorts: 'TikTok + Reels + Shorts',
      platformsOptionAllShortsHint:
        'Один вертикальный ролик для всех платформ коротких видео',
      campaignGoalOptionLaunch: 'Запуск продукта',
      campaignGoalOptionLaunchHint:
        'Представить продукт и заинтересовать аудиторию',
      campaignGoalOptionConversions: 'Повысить конверсию',
      campaignGoalOptionConversionsHint:
        'Подвести зрителя к покупке или заявке',
      campaignGoalOptionBenefits: 'Объяснить выгоды',
      campaignGoalOptionBenefitsHint:
        'Сделать ключевую ценность очевидной и запоминающейся',
      campaignGoalOptionRetarget: 'Ретаргетинг',
      campaignGoalOptionRetargetHint:
        'Вернуть заинтересованную аудиторию и подтолкнуть её к покупке',
      submit: 'Создать варианты концепции ролика',
    },
    promptBox: {
      dropMedia: 'Перетащите изображение или видео',
      placeholder:
        'Начните с идеи. Используйте @, чтобы добавить референс, или /, чтобы выбрать навык Агента.',
    },
    conceptPicker: {
      title: 'Выберите визуальную концепцию',
      description:
        'Просмотрите варианты в галерее и выберите подходящее направление.',
      generatedImages: 'Создано изображений: {{count}}',
      generatingImages: 'Создаём изображения: {{count}}…',
      generatedDirections: 'Создано вариантов: {{count}}',
      generatedImage: 'Созданное изображение',
      imageLabel: 'Изображение {{index}}',
      directionLabel: 'Вариант {{index}}',
      chooseDirection: 'Выбрать этот вариант',
      ready: 'Готово',
      generating: 'Создаётся…',
      expandItem: 'Развернуть {{label}}',
      collapseItem: 'Свернуть {{label}}',
      previewImage: 'Открыть {{label}} в галерее',
      useConceptImage: 'Выбрать изображение {{index}}: {{title}}',
      useConceptDirection: 'Выбрать вариант {{index}}: {{title}}',
      useVideoImage: 'Использовать изображение {{index}} для видео',
    },
    finalImagesTool: {
      title: 'Финальные изображения',
      description_one: '{{count}} вариант высокого разрешения в одном стиле',
      description_other: '{{count}} варианта высокого разрешения в одном стиле',
      generating: 'Создаём три изображения высокого разрешения…',
      concept: 'Концепция: {{title}}',
    },
    gallery: {
      hideWatermark: 'Скрыть водяной знак',
      watermarkAllResources: 'Для всех созданных изображений и видео',
      preparingDownload: 'Подготовка…',
      downloadFailed: 'Не удалось скачать. Попробуйте ещё раз.',

      generations: 'Результаты',
      cuts: 'Монтаж',
      back: 'Назад к этапу',
      generationStages: 'Этапы создания',
      filter: 'Фильтр галереи',
      layout: 'Изменить раскладку',
      addToFavorites: 'Добавить в избранное',
      removeFromFavorites: 'Убрать из избранного',
      moreActions: 'Другие действия',
      selectAsset: 'Выбрать материал',
      addToCut: 'Добавить в монтаж',
      download: 'Скачать',
      copyLink: 'Скопировать ссылку',
      delete: 'Удалить',
      loading: 'Загрузка галереи…',
      loadingHint: 'Загружаем материалы сессии из хранилища.',
      emptyTitle: 'Результатов пока нет',
      emptyHint:
        'Загрузите фото продукта или создайте изображения для кампании — они будут появляться здесь по ходу работы.',
      generatedDialogueAudio: 'Созданная аудиодорожка с диалогом',
    },
    videoJobTool: {
      title: 'Создание рекламного видео',
      description: 'Создаём новое рекламное видео по вашим референсам',
      progressLabel: 'Примерный прогресс создания видео',
      percent: 'Примерный прогресс: {{progress}}%',
      canvasHint: 'Готовое видео автоматически появится в рабочей области.',
      direction: 'Выбранный вариант: {{title}}',
      job: 'Задача № {{id}}',
      status: {
        queued: 'Видео в очереди…',
        processing: 'Создаём рекламное видео…',
        succeeded: 'Видео готово.',
        failed: 'Не удалось сгенерировать видео.',
        cancelled: 'Генерация видео отменена.',
      },
    },
    navigation: {
      home: 'Главная',
      agent: 'Агент',
      generate: 'Создать',
      assets: 'Материалы',
      primary: 'Основная навигация',
      mobile: 'Мобильная навигация студии',
      close: 'Закрыть навигацию',
      myloLab: 'Mylo lab',
    },
    shell: {
      currentRegion: 'Текущий регион: {{region}}',
      switchRegion: 'Сменить регион?',
      switchRegionDescription:
        'После смены региона потребуется войти снова. Данные рабочих пространств между регионами не переносятся.',
      cancel: 'Отмена',
      switch: 'Сменить регион',
    },
    home: {
      greeting: 'Привет, {{name}}! Что вы хотите создать?',
      getStarted: 'Начать',
      presetCategories: 'Категории шаблонов',
      creativeShortcuts: 'Быстрые действия',
      creativePresets: 'Творческие шаблоны',
      allSkills: 'Все навыки',
      shortcuts: {
        editTimeline: 'Перейти к монтажу',
        seedance: 'Мыло Видео 2.5',
        doubao: 'Doubao',
        adCampaign: 'Рекламная кампания',
        moodBoard: 'Мудборд',
      },
      tabs: {
        marketing: 'Маркетинговые кампании',
        movies: 'Кино',
        social: 'Социальные сети',
        education: 'Образовательный контент',
        experimental: 'Экспериментальное искусство',
        other: 'Другое',
      },
      presets: {
        adapt: 'Адаптировать одну идею для всех платформ',
        posts: 'Создать публикации на неделю',
        remix: 'Адаптировать тренд под мой продукт',
        thumbnails: 'Создать набор обложек',
        reel: 'Создать короткий вертикальный ролик',
      },
    },
    assets: {
      eyebrow: 'Библиотека рабочего пространства',
      title: 'Материалы',
      description:
        'Используйте изображения, видео и аудио в разных сессиях Агента.',
      upload: 'Загрузить',
      uploading: 'Загрузка · {{count}}',
      search: 'Поиск материалов',
      searchPlaceholder: 'Найти материал…',
      sessionGenerations: 'Результаты этой сессии',
      sessionGenerationsError:
        'Не удалось загрузить результаты этой сессии. Повторите попытку.',
      sessionGenerationsEmptyTitle: 'В этой сессии пока нет результатов',
      sessionGenerationsEmptyDescription:
        'Созданные изображения, видео и концепции появятся здесь.',
      showAll: 'Показать все материалы',
      retry: 'Повторить',
      tryAgain: 'Повторите попытку или выберите другой материал.',
      errors: {
        deleteForbidden:
          'Удалить материал может только его автор или администратор рабочего пространства.',
        deleteInUse:
          'Материал используется в генерации или проекте. Сначала удалите его оттуда.',
        deleteMissing:
          'Материал больше недоступен. Обновите библиотеку и повторите попытку.',
        deleteFailed: 'Не удалось удалить материал. Повторите попытку.',
        favoriteFailed: 'Не удалось обновить избранное. Повторите попытку.',
      },
      deleteConfirm: 'Удалить {{name}}?',
      deleteDescription:
        'Материал {{name}} будет удалён из библиотеки рабочего пространства.',
      cancel: 'Отмена',
      emptyTitle: 'Материалов пока нет',
      emptyDescription: 'Загрузите изображение, видео или аудиофайл.',
      select: 'Выбрать {{name}}',
      preview: 'Просмотреть {{name}}',
      loadingMore: 'Загружаем ещё…',
      retryLoadingMore: 'Повторить загрузку',
      retryLoading: 'Повторить загрузку материалов',
      pickerDescription:
        'Прикрепите к сообщению материал из рабочего пространства.',
      uploadMedia: 'Загрузить материалы',
      dropOrUpload: 'Перетащите или загрузите файлы',
      mediaTypes: 'Изображение, видео, аудио',
      image: 'Изображение',
      video: 'Видео',
      audio: 'Аудио',
      loadingVideo: 'Загружаем видео…',
      file: 'Файл',
      delete: 'Удалить',
      editVideo: 'Редактировать видео',
      deleteLabel: 'Удалить {{name}}',
      editVideoLabel: 'Редактировать видео {{name}}',
      uploadActivity: 'Ход загрузки',
      uploads: 'Загрузки',
      activeUploads: 'Активных загрузок: {{count}}',
      retryUpload: 'Повторить {{name}}',
      dismissUpload: 'Скрыть {{name}}',
      status: {
        queued: 'В очереди',
        preparing: 'Подготовка',
        uploading: 'Загрузка',
        complete: 'Готово',
        failed: 'Ошибка',
      },
    },
    videoEditor: {
      includeWatermark: 'Сохранить водяной знак',
      chooseTitle: 'Выберите видео для редактирования',
      chooseDescription:
        'Выберите видео из рабочего пространства, чтобы начать монтаж.',
      opening: 'Открываем {{name}}…',
      openError: 'Не удалось открыть это видео. Выберите другой клип.',
      videoAssets: 'Видеоматериалы',
      searchAssets: 'Поиск материалов',
      searchAssetsPlaceholder: 'Найти материал…',
      uploadFiles: 'Перетащите или загрузите файлы',
      loadingAssets: 'Загрузка материалов',
      timeline: 'Таймлайн видео',
      playhead: 'Позиция воспроизведения',
      clip: 'Клип',
      preparingMedia: 'Подготавливаем медиа…',
      preview: 'Предпросмотр видео',
      playPreview: 'Воспроизвести',
      pausePreview: 'Приостановить',
      tools: 'Инструменты монтажа',
      undo: 'Отменить',
      redo: 'Повторить',
      split: 'Разделить',
      mute: 'Выключить звук',
      unmute: 'Включить звук',
      deleteClip: 'Удалить клип',
      clipActions: 'Действия с клипом',
      editClip: 'Редактировать клип',
      splitShots: 'Разделить на фрагменты',
      splitAudio: 'Отделить звуковую дорожку',
      splitAudioUnavailable: 'Отдельные аудиодорожки пока недоступны',
      rippleDelete: 'Удалить со сдвигом',
      all: 'Все',
      uploads: 'Загрузки',
      folders: 'Папки',
      favorites: 'Избранное',
      addFavorite: 'Добавить {{name}} в избранное',
      removeFavorite: 'Удалить {{name}} из избранного',
      recents: 'Недавние',
      supportedMedia: 'Изображение, видео, PDF, аудио',
      noVideoAssets: 'Видеоматериалов пока нет',
      uploadClipHint: 'Загрузите клип, чтобы начать.',
      selectClip: 'Выбрать клип {{id}}',
      trimStart: 'Обрезать начало клипа {{id}}',
      trimEnd: 'Обрезать конец клипа {{id}}',
      muteClip: 'Выключить звук клипа',
      unmuteClip: 'Включить звук клипа',
      loadError:
        'Не удалось загрузить видеопроект. Вернитесь к материалам и заново откройте исходное видео.',
      exportUnavailable: 'Статус экспорта недоступен',
      exportRevision: 'Экспортировать новую версию',
      exported: 'Экспорт завершён',
      exporting: 'Экспорт: {{progress}}%',
      export: 'Экспорт',
      back: 'Назад',
      projectName: 'Название проекта',
      renameFailed: 'Не удалось переименовать',
      saving: 'Сохраняем…',
      saveFailed: 'Не удалось сохранить',
      retrySave: 'Повторить сохранение',
      newerVersion: 'Доступна новая версия',
      saved: 'Сохранено',
      retryExport: 'Повторить экспорт',
      downloadMp4: 'Скачать MP4',
      download: 'Скачать',
      closePanel: 'Закрыть боковую панель',
      openPanel: 'Открыть боковую панель',
      recoveredDraft: 'Восстановленный черновик',
      recoveryAvailable: 'В браузере есть несохранённые изменения.',
      restoreEdits: 'Восстановить',
      discard: 'Не восстанавливать',
      addAssetFailed:
        'Не удалось добавить материал. Проверьте файл и повторите попытку.',
      chooseAssetAgain: 'Выбрать материал',
      createCut: 'Создать версию монтажа',
      generations: 'Результаты',
      sessionGenerationsEmpty: 'Результаты этой сессии появятся здесь',
      cuts: 'Версии монтажа',
      newCut: 'Новая версия',
      creatingCut: 'Создаём версию…',
      createCutFailed: 'Не удалось создать версию монтажа. Попробуйте ещё раз.',
      emptyCut: 'Добавьте материалы, чтобы начать монтаж',
      selectOrDropMedia: 'Выберите или перетащите видео, аудио или изображения',
      cutActions: 'Действия для {{name}}',
      renameCut: 'Переименовать',
      duplicateCut: 'Дублировать',
      deleteCut: 'Удалить',
      deleteCutConfirmTitle: 'Удалить эту версию?',
      deleteCutConfirmDescription:
        '«{{name}}» будет удалена без возможности восстановления.',
      cancel: 'Отмена',
      assetDialogTitle: 'Добавить материалы',
      closeAssetDialog: 'Закрыть окно выбора материалов',
      noFavoriteAssets: 'В избранном пока нет материалов',
      noMediaAssets: 'Материалов пока нет',
      keyboardShortcuts: 'Горячие клавиши',
      shortcuts: {
        playbackNavigation: 'Воспроизведение и навигация',
        playPause: 'Воспроизвести / приостановить',
        skipBack: 'Назад на 5 секунд',
        skipForward: 'Вперёд на 5 секунд',
        stepBack: 'Назад на 1 кадр',
        stepForward: 'Вперёд на 1 кадр',
        previousEdge: 'Предыдущая граница клипа',
        nextEdge: 'Следующая граница клипа',
        jumpStart: 'Перейти в начало',
        jumpEnd: 'Перейти в конец',
        zoomIn: 'Увеличить масштаб',
        zoomOut: 'Уменьшить масштаб',
        selecting: 'Выделение',
        selectAll: 'Выделить все клипы',
        selectAcross: 'Выделить на всех дорожках',
        selectTrack: 'Выделить на одной дорожке',
        markStart: 'Отметить начало выделения',
        markEnd: 'Отметить конец выделения',
        clearSelection: 'Снять выделение',
        editing: 'Монтаж',
        split: 'Разделить по позиции курсора',
        copy: 'Копировать выбранные клипы',
        paste: 'Вставить в позицию курсора',
        deleteGap: 'Удалить, сохранив пробел',
        rippleDelete: 'Удалить и сдвинуть клипы влево',
        undo: 'Отменить',
        redo: 'Повторить',
        duplicate: 'Дублировать при перетаскивании',
      },
      shortcutPlay: 'Воспроизведение / пауза',
      shortcutSkip: 'Перемотать на 5 секунд',
      shortcutFrame: 'Перейти на один кадр',
      shortcutEdge: 'Предыдущая / следующая граница клипа',
      shortcutSplit: 'Разделить в позиции курсора',
      shortcutDelete: 'Удалить и оставить пробел',
      shortcutRippleDelete: 'Удалить и сдвинуть влево',
      shortcutHistory: 'Отменить / повторить',
      zoomOut: 'Уменьшить',
      zoomIn: 'Увеличить',
      fitTimeline: 'Показать весь таймлайн',
      addClip: 'Добавить клип',
      preparingMetadata: 'Подготавливаем данные видео…',
      mobileEditingHint:
        'Перетаскивание и обрезка доступны только на компьютере. Здесь можно просматривать видео, экспортировать его и использовать остальные инструменты панели.',
      assets: 'Материалы',
      agent: 'Агент',
      editWithAgent: 'Редактировать с Агентом',
      agentDescription:
        'Опишите, в какой последовательности нужно расположить материалы.',
      sendMessage: 'Отправить сообщение',
      sendMessagePlaceholder: 'Введите сообщение…',
    },
    agentUi: {
      defaultChat: 'Чат с Агентом',
      justNow: 'Только что',
      recents: 'Недавние',
      recentChats: 'Недавние чаты',
      recentChatsLabel: 'Недавние чаты с Агентом',
      allChats: 'Все чаты',
      viewAllChats: 'Показать все чаты',
      closeChatHistory: 'Закрыть историю чатов',
      loadingChats: 'Загружаем чаты…',
      loadingMoreChats: 'Загружаем другие чаты…',
      retryLoadingMoreChats: 'Повторить загрузку чатов',
      sessionGenerating: 'Идёт создание',
      sessionQueued: 'В очереди — создание ещё не началось',
      sessionUnread: 'Не прочитано',
      sessionAwaitingUser: 'Ожидает вашего ответа',
      noChats: 'Чатов пока нет. Начните новый чат, и он появится здесь.',
      sessionActions: 'Действия сессии',
      sessionActionsFor: 'Действия для {{title}}',
      chatActions: 'Действия чата',
      newChat: 'Новый чат',
      newChatTooltip: 'Новый чат',
      rename: 'Переименовать',
      delete: 'Удалить',
      seeGenerationsInAssets: 'Показать генерации в Материалах',
      deleteSession: 'Удалить сессию',
      deleteSessionConfirm: 'Удалить «{{title}}»?',
      deleteSessionDescription:
        'Сессия исчезнет из недавних чатов. Это действие нельзя отменить.',
      deleteSessionFailed: 'Не удалось удалить сессию. Повторите попытку.',
      renameChat: 'Переименовать чат',
      chatTitle: 'Название чата',
      titleRequired: 'Введите название',
      renameFailed: 'Не удалось переименовать чат',
      cancel: 'Отмена',
      save: 'Сохранить',
      skills: 'Навыки',
      creationMode: 'Режим создания',
      agentMode: 'Режим Агента',
      imageGeneration: 'Изображения',
      videoGeneration: 'Видео',
      model: 'Модель',
      aspectRatio: 'Соотношение сторон',
      smartAspectRatio: 'Автоформат',
      resolution: 'Разрешение',
      quantity: 'Количество',
      duration: 'Длительность',
      seconds: 'с',
      generateAudio: 'Аудио',
      quoteFailed: 'Не удалось рассчитать расход мыла',
      quoteRequiresPlan:
        'Для выбранной модели нужен действующий платный тариф. Оформите или продлите подписку, чтобы продолжить.',
      viewPlans: 'Посмотреть тарифы',
      retryQuote: 'Повторить расчёт',
      quoteUnavailable: 'Недоступно',
      estimatedCredits: 'Ожидаемый расход',
      calculatingCredits: 'Расчёт…',
      videoReferenceMode: 'Режим референса',
      allReference: 'Все референсы',
      firstFrame: 'Первый кадр',
      videoContinuation: 'Продолжить видео',
      imagePromptPlaceholder: 'Опишите изображение, которое хотите создать…',
      videoPromptPlaceholder:
        'Опишите движение и сцену, которые хотите создать…',
      directCreationProgress: {
        preparing: {
          title: 'Подготавливаем генерацию',
          detail: 'Настраиваем параметры создания',
        },
        queued: {
          title: 'Задача в очереди',
          detail: 'Генерация начнётся в ближайшее время',
        },
        processing: {
          title: 'Идёт генерация',
          detail: 'Можно продолжать работу — результат появится здесь',
        },
      },
      toolCalls: {
        recognizeImage: 'Анализируем изображение…',
        recognizeVideo: 'Анализируем видео…',
        updateImage: 'Создаём обновлённое изображение…',
        askUser: 'Открываем форму с деталями…',
        calling: 'Запускаем {{name}}…',
        updatedImage: 'Обновлённое изображение создано.',
      },
      attachmentErrors: {
        selectWorkspaceImages:
          'Выберите рабочее пространство перед добавлением изображений.',
        selectWorkspaceMedia:
          'Выберите рабочее пространство перед добавлением материалов.',
        imageLoad:
          'Не удалось загрузить изображение. Попробуйте выбрать его снова.',
        videoLoad: 'Не удалось загрузить видео. Попробуйте выбрать его снова.',
        limit: 'Можно прикрепить не более {{count}} материалов.',
      },
      loadingChat: 'Загружаем чат с Агентом…',
      skill: {
        timeline: {
          label: 'Таймлайн',
          description: 'Спланируйте этапы работы от идеи до финальной сдачи.',
        },
        adCampaign: {
          label: 'Рекламная кампания',
          description:
            'Создайте кампанию: от идеи до готовых видео и изображений для каждой платформы.',
        },
        adVideo: {
          label: 'Рекламное видео',
          description:
            'Создайте короткий рекламный ролик с ярким началом и призывом к действию.',
        },
        moodBoard: {
          label: 'Мудборд',
          description:
            'Задайте визуальное направление проекта с помощью подобранных референсов.',
        },
        motionGraphic: {
          label: 'Моушн-графика',
          description:
            'Превратите текст, диаграммы и графику в анимационную концепцию.',
        },
      },
      assets: 'Материалы',
      gallery: 'Галерея сессии',
      galleryTitle: 'Галерея',
      galleryDescription:
        'Здесь собраны загруженные изображения, референсы, концепции и результаты этой сессии.',
      galleryLoading: 'Загружаем галерею…',
      galleryEmpty: 'Изображений пока нет',
      galleryLoadingDescription: 'Загружаем материалы сессии из хранилища.',
      galleryEmptyDescription:
        'Загрузите фото продукта или создайте изображения для кампании. Они появятся здесь, а чат останется справа.',
      assetKind: {
        upload: 'загрузка',
        reference: 'референс',
        concept: 'концепция',
        generated: 'результат',
      },
      generatedVideo: 'Созданное рекламное видео',
      generatedImage: 'Созданное изображение',
      galleryLabels: {
        audio: 'аудио',
        upload: 'Загрузка',
        uploads: 'Загрузки',
        video: 'видео',
        reference: 'Референс',
        references: 'Референсы',
        productReference: 'Референс продукта',
        concepts: 'Концепции',
        generated: 'Созданное',
        generatedImage: 'Созданное изображение',
        generatedVideo: 'Созданное видео',
      },
      previewImage: 'Предпросмотр изображения',
      previewAsset: 'Предпросмотр: {{name}}',
      contextAssetUnavailable: 'Предпросмотр недоступен',
      playMedia: 'Воспроизвести {{name}}',
      copyMessage: 'Копировать сообщение',
      messageCopied: 'Скопировано',
      stopGenerating: 'Остановить генерацию',
      sendMessage: 'Отправить сообщение',
      removeAttachment: 'Удалить {{name}}',
      clear: 'Очистить',
      clearComposer: 'Очистить запрос и материалы',
      attachment: 'вложение',
      addMoreMedia: 'Добавить изображения или видео',
      uploadMedia: 'Загрузить изображение или видео',
      references: 'Референсы',
      renameReference: 'Переименовать {{name}}',
      creativeShortcuts: 'Быстрые действия',
      creativePresets: 'Творческие шаблоны',
      agentPrompt: 'Запрос Агенту',
      openAssets: 'Открыть материалы',
      openSkills: 'Открыть навыки',
      composerTitle: 'Что создадим?',
      composerDescription: 'Создавайте и развивайте контент с Агентом.',
      generationSettings: 'Настройки генерации',
      generationSettingsDescription:
        'Выберите, когда и каким образом Агент будет создавать изображения и видео.',
      whenGenerating: 'Создание материалов',
      optimizeGenerations: 'Оптимизация генерации',
      generationAsk: 'С подтверждением',
      generationAuto: 'Автоматически',
      generationQuality: 'Качество',
      generationSpeed: 'Скорость',
      generationCost: 'Стоимость',
      generationCustom: 'Свои настройки',
      freePlanGenerationLimit:
        'Ограничения Free: настройки изображений применяются; выбор видеомоделей ограничен разрешением до 720p и одной одновременной задачей.',
      autoCreditLimit: 'Автолимит кредитов на одну операцию',
      customGenerationInstructions: 'Пользовательские предпочтения',
      customGenerationPlaceholder:
        'Например: предпочитаемые модели, разрешение, соотношение сторон или бюджет',
      setGenerationDefault: 'Использовать по умолчанию в новых сессиях',
      savingGenerationDefault: 'Сохраняем настройки…',
      planTitle: 'План Агента',
      planThinking: 'Планируем следующие шаги…',
      planStepCount_one: 'Запланировано шагов: {{count}}',
      planStepCount_other: 'Запланировано шагов: {{count}}',
      planStatus: 'Статус шага: {{status}}',
      planStepProgress: 'Прогресс: {{step}}',
      planEdit: 'Изменить план',
      planEditSummary: 'Описание действия',
      planEditModel: 'Модель',
      planModelAutomatic: 'Автоматически',
      planEditPrompt: 'Промпт',
      planEditParameters: 'Параметры (JSON)',
      planEditOutputCount: 'Результаты',
      planEditReferences: 'Цели и референсы',
      planEditReferenceRole: 'Роль референса',
      planEditRemoveReference: 'Удалить референс',
      planEditAddReference: 'Добавить референс',
      planEditSelectReference: 'Выберите материал…',
      planEditAdd: 'Добавить',
      planEditCancel: 'Отмена',
      planEditSave: 'Сохранить и пересчитать',
      planEditSaving: 'Пересчитываем…',
      planEditInvalidParameters: 'Введите параметры как JSON-объект.',
      planEditFailed:
        'Не удалось обновить план. Проверьте поля и повторите попытку.',
      planAssumptions: 'Что учёл Агент',
      planDetails: 'Подробнее',
      planFailureRealPerson:
        'Эта модель не поддерживает анимацию изображений реальных людей. Используйте иллюстрацию или изображение вымышленного персонажа.',
      planFailureGeneric:
        'Не удалось создать результат. Проверьте материалы или настройки и повторите попытку.',
      approvePlanStepPrefix: 'Подтвердить ·',
      approvingPlanStep: 'Подтверждаем…',
      applyTimelineEdit: 'Применить изменения',
      timelineEditPreview: 'Изменений на таймлайне: {{count}}',
      timelineEditTarget: '{{name}} · версия {{revision}}',
      planPricingUnavailable:
        'Не удалось рассчитать стоимость. Запуск недоступен.',
      retryPlanStep: 'Повторить',
      retryFailedOutputs: 'Повторить неудачные попытки ({{count}})',
      skipPlanStep: 'Пропустить',
      saveWorkspaceReference: 'Сохранить как референс рабочего пространства',
      planInputs: 'Исходные материалы',
      planInputRole: {
        target: 'Цель',
        reference: 'Референс',
        identity_reference: 'Референс персонажа',
        motion_reference: 'Референс движения камеры',
        first_frame: 'Первый кадр',
        source: 'Источник',
      },
      planConstraint: { keep: 'Сохранить', vary: 'Изменить' },
      planExecutionStatus: {
        awaiting_confirmation: 'Ожидание вашего подтверждения…',
        queued: 'Генерация добавлена в очередь…',
        processing: 'Создаём материалы…',
        succeeded: 'Генерация завершена',
        failed: 'Ошибка генерации. Можно продолжить работу в чате с Агентом.',
        cancelled:
          'Генерация отменена. Можно продолжить работу в чате с Агентом.',
      },
      planResultComplete: 'Готово: {{summary}}',
      planResultCompleteWithOutputs:
        'Готово: {{summary}}. Создано результатов: {{count}}. Их можно доработать в чате.',
      planResultFailed:
        'Не выполнено шагов: {{count}}. Откройте план, чтобы посмотреть подробности и повторить попытку.',
    },
    videoParams: {
      eyebrow: 'Новое видео',
      description:
        'Создайте рекламный ролик на основе загруженных изображений и видеоматериалов.',
      duration: 'Длительность (сек.)',
      durationHint: 'Укажите целое число от 4 до 30 секунд.',
      durationError: 'Длительность должна быть от 4 до 30 секунд.',
      aspectRatio: 'Соотношение сторон',
      resolution: 'Разрешение',
      modelSelection: 'Выбор модели',
      auto: 'Автовыбор',
      manual: 'Выбрать модель',
      model: 'Модель видео',
      paid: 'Платный план',
      badges: {
        economy: 'Экономичная',
        fast: 'Быстрая',
        professional: 'Профессиональная',
        latest: 'Новейшая',
      },
      dynamicDurationHint: 'Укажите целое число от 4 до {{max}} секунд.',
      audio: 'Создавать исходный звук',
      audioHint: 'Диалоги, атмосфера и эффекты, если модель поддерживает.',
      adjusted: 'Параметры изменены: {{before}} → {{after}}',
      calculating: 'Рассчитываем мыло…',
      estimatedPrefix: 'Примерная стоимость:',
      estimated: 'Примерная стоимость в кредитах: {{count}}',
      adjust: 'Измените настройки, чтобы обновить расчёт.',
      quoteErrorHint:
        'Измените параметры видео, чтобы заново рассчитать стоимость.',
      insufficientCredits:
        'Не удалось начать создание видео: недостаточно кредитов. Требуется кредитов: {{count}}. Настройки сохранены. Пополните баланс или измените параметры и повторите попытку.',
      generationFailed:
        'Не удалось начать создание видео: {{message}}. Настройки сохранены — повторите попытку.',
      requestMessage:
        'Создать видео «{{direction}}»: {{duration}} с · {{ratio}} · {{resolution}}',
      generate: 'Создать видео',
      generatePrefix: 'Создать ·',
      generateWithCredits: 'Создать · {{count}} кредитов',
    },
    assetConfirmation: {
      accept: 'Принять',
      acceptHint: 'Использовать это наблюдение при генерации',
      ignore: 'Игнорировать',
      ignoreHint: 'Не учитывать это наблюдение с низкой уверенностью',
      closeTool: 'Закрыть подтверждение материала',
      previousQuestion: 'Предыдущий вопрос',
      nextQuestion: 'Следующий вопрос',
      stepOf: 'из',
      skip: 'Пропустить',
      required: 'Обязательно',
      requiredHint: 'Ответьте на все вопросы, чтобы продолжить генерацию.',
      submit: 'Подтвердить и продолжить',
    },
    directVideoSetup: {
      ratioEyebrow: 'Кадр видео',
      invalidRatio: 'Формат {{ratio}} не поддерживается. Выберите доступный.',
      chooseRatio: 'Выберите соотношение сторон видео',
      ratioSelected: 'Выбрано {{ratio}}.',
      ratioSelectedChooseDirection:
        'Выбрано {{ratio}}. Теперь выберите направление видео.',
      direction: 'Направление видео',
      directionQuestion: 'Как должно двигаться изображение?',
      directionPlaceholder: 'Опишите движение, камеру и темп',
      subtle: 'Лёгкое движение',
      subtleHint: 'Сохранить композицию и добавить естественное движение',
      subtleValue:
        'Сохранить композицию и объект, добавив лишь лёгкое естественное движение',
      pushIn: 'Кинематографический наезд',
      pushInHint: 'Медленно приблизить камеру к объекту',
      pushInValue:
        'Медленно приблизить камеру к объекту, создавая кинематографическую глубину',
      orbit: 'Облёт объекта',
      orbitHint: 'Плавно показать объект с разных сторон',
      orbitValue:
        'Плавно перемещать камеру вокруг объекта, сохраняя его детали',
      dynamic: 'Динамичное раскрытие',
      dynamicHint: 'Более активное движение и чёткий ритм',
      dynamicValue:
        'Постепенно раскрыть объект динамичным движением камеры и чётким ритмом',
      typeOwnAnswer: 'Указать своё направление',
      customLabel: 'Свой вариант: {{field}}',
      closeTool: 'Закрыть выбор направления',
      previousQuestion: 'Предыдущий вопрос',
      nextQuestion: 'Следующий вопрос',
      stepOf: 'из',
      skip: 'Пропустить',
      required: 'обязательно',
      continue: 'Продолжить',
      submit: 'Выбрать направление',
    },
  },
} as const satisfies TranslationResources;
